import { gql } from '@apollo/client';
import { TermCategoryFragment } from '../../../queries';

export const ParagraphSearchByIdFragment = gql`
  fragment ParagraphSearchById on ParagraphSearchById {
    title
  }
`;
